import { Component, Input } from '@angular/core'
import { NgClass } from '@angular/common'
import { NotificationStatus, NotificationStatusStyleMap, NotificationStatusConfig } from '../../models'

@Component({
    selector: 'ach-notification-status-badge',
    standalone: true,
    imports: [NgClass],
    template: `<span class="status-badge" [ngClass]="config.cssClass">{{ config.label }}</span>`,
    styleUrl: '../status-badge/status-badge.component.scss',
})
export class NotificationStatusBadgeComponent {
    @Input({ required: true }) status!: NotificationStatus

    get config(): NotificationStatusConfig {
        return NotificationStatusStyleMap[this.status]
    }
}
